class ComponentsThemeManager {
  static mountOnPropName = 'DescopeThemeManager';

  #themes = {};

  #currentThemeName = 'light';

  #callbacks = new Set();

  #notify() {
    this.#callbacks.forEach((cb) => cb?.());
  }

  get currentThemeName() {
    return this.#currentThemeName;
  }

  set currentThemeName(themeName) {
    this.#currentThemeName = themeName;
    this.#notify();
  }

  get currentTheme() {
    return this.#themes[this.currentThemeName];
  }

  onCurrentThemeChange(cb) {
    this.#callbacks.add(cb);

    return () => {
      this.#callbacks.delete(cb);
    };
  }

  set themes(themes) {
    this.#themes = themes;
    this.#notify();
  }

  get hasThemes() {
    return !!Object.keys(this.#themes).length;
  }
}

export const componentsThemeManager = new ComponentsThemeManager();
